import { Col, Divider, Row } from 'antd';
import { cloneDeep, maxBy } from 'es-toolkit';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../components/Buttons/Button';
import PrimaryLabel from '../../../../../components/Labels/PrimaryLabel';
import OverChargeNoteCard from '../../Components/Edit/Components/OverChargeNotes/OverChargeNoteCard';

const CreateOverChargeNotes = ({ notesList, setNotesList }) => {
  const { t } = useTranslation(['translation']);

  const setEditMode = (index, val) => {
    const notesListLocal = cloneDeep(notesList);
    notesListLocal[index].editMode = val;
    setNotesList(notesListLocal);
  };

  const handleCancel = (index, isNew) => () => {
    const notesLocal = cloneDeep(notesList);
    if (isNew) {
      notesLocal.splice(index, 1);
    } else {
      notesLocal[index] = {
        ...notesLocal[index],
        editMode: false,
      };
    }
    setNotesList(notesLocal);
  };

  const handleSubmit = (data, index) => {
    const notesLocal = cloneDeep(notesList);
    notesLocal[index] = { ...data, isNew: false, editMode: false };
    setNotesList(notesLocal);
  };

  const handleDelete = (index) => () => {
    const notesLocal = cloneDeep(notesList);
    notesLocal.splice(index, 1);
    setNotesList(notesLocal);
  };

  const handleAddNew = () => () => {
    let notesListLocal = cloneDeep(notesList);
    let nextSequence = maxBy(notesListLocal, ({ sequenceNo }) => Number(sequenceNo));
    nextSequence = nextSequence ? nextSequence.sequenceNo : 0;
    notesListLocal = [
      {
        commentType: undefined,
        commentText: undefined,
        sequenceNo: nextSequence + 1,
        oldCommentType: null,
        dirtyFlag: 'i',
        isNew: true,
        editMode: true,
      },
      ...notesListLocal,
    ];
    setNotesList(notesListLocal);
  };
  return (
    <div>
      <Row className="align-items-center" justify="space-between">
        <Col>
          <PrimaryLabel className="fw-700 f-18">{t('translation:claims.overchargeClaimNotes')}</PrimaryLabel>
        </Col>
        <Col>
          <Row justify="end" gutter={16}>
            <Col>
              <Button onClick={handleAddNew()}>{t('translation:claims.addNewNote')}</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      <div className="flex-1 custom-scroll-bar">
        <div>
          {notesList.map((row, index) => (
            <OverChargeNoteCard
              noteDetails={row}
              key={row.sequenceNo}
              index={index}
              editMode={Boolean(row.editMode)}
              setEditMode={setEditMode}
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
              handleDelete={handleDelete}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CreateOverChargeNotes;
